import { useState, useMemo, useEffect } from "react";
import { PageModule, PageModuleGroupModules } from "types/working-model";

export const useLoadCurrentItemModuleIds = (pageModules: PageModule[] | null, pageModuleGroup: PageModuleGroupModules | null) => {
	const [currentItemModuleIds, setCurrentItemModuleIds] = useState<number[]>([]);

	const moduleMap = useMemo(() => {
		return Object.fromEntries(pageModules?.map(module => [module.id, module]) || []);
	}, [pageModules]);

	const modules = useMemo(() => {
		return pageModuleGroup?.modules.map((modId: number) => {
			return moduleMap[modId];
		}).filter((mod: PageModule | undefined) => !!mod) ?? [];
	}, [pageModuleGroup, moduleMap]);

	useEffect(() => {
		const currentItems = modules.flatMap(module => module.modules?.map(mod => {
			return { ...mod, page_module: module.id };
		}) ?? []);

		setCurrentItemModuleIds(currentItems.map(ci => ci.module_id));
	}, [modules]);

	return useMemo(() => ({ currentItemModuleIds }), [currentItemModuleIds]);
};
